module.exports = __webpack_public_path__ + "img/104.2.ae2ca2ae.png";